<template>
  <div class="dft-attr_container">
    <h4 class="dft-header">砍价</h4>
    <!-- 商品 -->
    <div class="attr-item-box" v-for="(item, index) in value" :key="index"
      :style="{ 'padding': item.isUse == false ? '0' : '6px' }">
      <div class="attr-item-typedata" v-if="item.sid == 'goods_weapp_s0'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <div class="addImgList">
            <div class="imgList_box">
              <div class="attr-list-item comp-item groupitem" v-for="(iitem, iiIndex) in item.groupList" :key="iiIndex">
                <div class="goodsinfo groupitem_line">
                  <div class="g_l_label" style="width: 60px;flex-shrink: 0;padding-bottom: 4px;">商品分类</div>
                  <div class="" v-if="iitem.categoryList">
                    <el-tag
                      :key="tag.id"
                      v-for="(tag,iiindex) in iitem.categoryList.filter(item=>item.level!=0)"
                      closable class="ctag_item"
                      :disable-transitions="false"
                      @close="handleTagClose(iitem.categoryList,iiindex)">
                      {{tag.categoryName}}
                    </el-tag>
                  </div>
                  <div class="upload_btn" @click="addClass(iiIndex)" style="margin-top: 8px;">
                    <i class="el-icon-plus"></i>
                    添加商品分类
                  </div>
                  <addClassPage
                    :ref="`addClassPage_${iitem.groupId}`"
                    :key="iitem.groupId"
                    v-model="iitem.categoryList"
                    :showDialog="showClassDialog&&showClassIndex==iiIndex"
                    @goBack="goBack"
                  ></addClassPage>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="attr-item-typedata" v-if="item.sid == 'goods_weapp_s1'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <div class="temp-box">
            <div class="temp-item" :class="item.value == iiIndex ? 'active_temp-item' : ''"
              v-for="(ii, iiIndex) in item.options" :key="iiIndex" @click="item.value = iiIndex">
              <el-image v-if="item.value == iiIndex && ii.img1" class="temp-item-img" :src="ii.img1"
                fit="contain"></el-image>
              <el-image v-else-if="ii.img2" class="temp-item-img" :src="ii.img2" fit="contain"></el-image>
              <div class="temp-item-name"><span class="mini_span">{{ ii.name }}</span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="attr-item-typedata" v-else-if="item.sid == 'goods_weapp_s2'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <div class="temp-box">
            <el-radio-group v-model="item.value" size="small">
              <el-radio-button label="0">砍价模式</el-radio-button>
              <el-radio-button label="1">无边白底</el-radio-button>
              <el-radio-button label="2">卡片投影</el-radio-button>
              <el-radio-button label="3">描边白底</el-radio-button>
              <el-radio-button label="4">无边透明底</el-radio-button>
              <el-radio-button v-if="value[1].value == 1" label="5">瀑布流</el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item.sid == 'goods_weapp_s3'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <el-select v-model="item.value" placeholder="请选择" style="width: 160px;">
            <el-option label="样式1" value="1" class="select-option"></el-option>
            <el-option label="样式2" value="2" class="select-option"></el-option>
            <el-option label="样式3" value="3" class="select-option"></el-option>
            <el-option label="样式4" value="4" class="select-option"></el-option>
            <el-option label="样式5" value="5" class="select-option"></el-option>
            <el-option label="样式6" value="6" class="select-option"></el-option>
            <el-option label="样式7" value="7" class="select-option"></el-option>
            <el-option label="样式8" value="8" class="select-option"></el-option>
          </el-select>
        </div>
      </div>
      <div v-if="item.sid == 'goods_weapp_s3' && ['3', '4', '7', '8'].includes(item.value)"
        class="flex justify-end align-center col-center row-center">
        <span style="font-size: 12px;">按钮文字：</span>
        <el-input v-model="item.options[item.value]" style="width: 120px;"></el-input>
      </div>
      <div class="attr-item-typestyle" v-else-if="value[3].value == '3' && item.sid == 'goods_weapp_s14'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <el-input v-model="item.value" style="width: 160px;"></el-input>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item.isUse != false && item.sid == 'goods_weapp_s4'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="item.value" size="small">
            <el-radio-button label="1">显示</el-radio-button>
            <el-radio-button label="2">不显示</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" style="position: relative;padding-bottom: 12px;"
        v-else-if="item.isUse != false && item.sid == 'goods_weapp_s5'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="item.value" size="small">
            <el-radio-button label="1">显示</el-radio-button>
            <el-radio-button label="2">不显示</el-radio-button>
          </el-radio-group>
        </div>
        <div class="info-set">此处显示商品的 ”分享描述“ 内容。</div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item.sid == 'goods_weapp_s6'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="item.value" size="small">
            <el-radio-button label="unset">直角</el-radio-button>
            <el-radio-button label="8px">圆角</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item.sid == 'goods_weapp_s7'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="item.value" size="small">
            <el-radio-button label="66.67%">3:2</el-radio-button>
            <el-radio-button label="100%">1:1</el-radio-button>
            <el-radio-button label="133.33%">3:4</el-radio-button>
            <el-radio-button label="56.25%">16:9</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item.sid == 'goods_weapp_s8'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="item.value" size="small">
            <el-radio-button label="cover">填充</el-radio-button>
            <el-radio-button label="contain">留白</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item.sid == 'goods_weapp_s9'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="item.value" size="small">
            <el-radio-button label="400">常规</el-radio-button>
            <el-radio-button label="600">加粗</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item.sid == 'goods_weapp_s10'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="item.value" size="small">
            <el-radio-button label="left">左对齐</el-radio-button>
            <el-radio-button label="center">居中对齐</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item.isUse != false && item.sid == 'goods_weapp_s11'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <el-slider v-model="item.value" :min="item.min" :max="item.max" show-input :show-input-controls="false"
            class="custon_slider" input-size="mini"></el-slider>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item.isUse != false && item.sid == 'goods_weapp_s12'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="item.value" size="small">
            <el-radio-button label="1">隐藏</el-radio-button>
            <el-radio-button label="2">不隐藏</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import addClassPage from '../addClassPage.vue'

export default {
  components: {
    draggable,
    addClassPage
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  model: {
    prop: 'value',
    event: 'changes'
  },
  data () {
    return {
      showDialog: false,
      showClassDialog: false,
      showSKDialog: false,
      gprefresh: true,
      showClassIndex: 0,
      showSKIndex: 0,
      groupRight: {
        name: 'itxst2',
        pull: false, // 拖出
        put: false // 拖入
      },
      // 模板默认数据
      assemblyAttr666: JSON.stringify(
        [
          {
            label: '砍价商品',
            value: [],
            key: 'goodsList',
            type: 'data',
            tag: '',
            sid: 'goods_weapp_s0',
            groupList: [{
              categoryList: []
            }]
          }, // 0
          {
            label: '列表样式',
            value: 0,
            key: 'listStyle',
            type: 'data',
            tag: '',
            sid: 'goods_weapp_s1',
            options: [
              { name: '一行一个', img1: 'https://img01.yzcdn.cn/upload_files/2022/08/23/FhW2ZJpDPxh0Q-ZTtfOJ7itWtZF_.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/08/23/Ft1GxcBJBmtbjahNVZOPWBrbIj3d.png' },
              { name: '一行两个', img1: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FluleLjR6gMJ9p_H9P5WEAhgPa8d.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FkdiKOW0JN9yIoDhGRXaeJQ6H8TJ.png' },
              { name: '一行三个', img1: 'https://img01.yzcdn.cn/upload_files/2022/08/23/FhW2ZJpDPxh0Q-ZTtfOJ7itWtZF_.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/08/23/Ft1GxcBJBmtbjahNVZOPWBrbIj3d.png' },
              { name: '大图模式', img1: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FluleLjR6gMJ9p_H9P5WEAhgPa8d.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FkdiKOW0JN9yIoDhGRXaeJQ6H8TJ.png' },
              { name: '横向滑动', img1: 'https://img01.yzcdn.cn/upload_files/2022/08/23/FhW2ZJpDPxh0Q-ZTtfOJ7itWtZF_.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/08/23/Ft1GxcBJBmtbjahNVZOPWBrbIj3d.png' },
              { name: '一大两小', img1: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FluleLjR6gMJ9p_H9P5WEAhgPa8d.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FkdiKOW0JN9yIoDhGRXaeJQ6H8TJ.png' }
            ]
          }, // 1
          {
            label: '商品样式',
            value: '0',
            key: 'goodsStyle',
            type: 'data',
            tag: '',
            sid: 'goods_weapp_s2',
            showList: {
              '0': '砍价模式',
              '1': '无边白底',
              '2': '卡片投影',
              '3': '描边白底',
              '4': '无边透明底',
              '5': '瀑布流'// 一行两个
            }
          }, // 2
          {
            label: '商品倒角',
            value: 'unset',
            sid: 'goods_weapp_s6',
            showList: {
              'unset': '直角',
              '8px': '圆角'
            },
            key: 'border-radius',
            type: 'style',
            tag: 'radio'
          }, // 3
          {
            label: '图片比例',
            value: '66.67%',
            sid: 'goods_weapp_s7',
            showList: {
              '66.67%': '3:2',
              '100%': '1:1',
              '133.33%': '3:4',
              '56.25%': '16:9'
            },
            key: 'padding-top',
            type: 'style',
            tag: 'radio'
          }, // 4
          {
            label: '图片填充',
            value: 'cover',
            sid: 'goods_weapp_s8',
            showList: {
              'cover': '填充',
              'contain': '留白'
            },
            key: 'fit',
            type: 'style',
            tag: 'radio'
          }, // 5
          {
            label: '文本样式',
            value: '400',
            sid: 'goods_weapp_s9',
            showList: {
              '400': '常规',
              '600': '加粗'
            },
            key: 'font-weight',
            type: 'style',
            tag: 'radio'
          }, // 6
          {
            label: '文本对齐',
            value: 'left',
            sid: 'goods_weapp_s10',
            showList: {
              'left': '左对齐',
              'center': '居中对齐'
            },
            key: 'text-align',
            type: 'style',
            tag: 'radio'
          }, // 7
          {
            label: '页面边距',
            value: 8,
            sid: 'goods_weapp_s11',
            min: 0,
            max: 30,
            key: 'padding',
            type: 'style',
            tag: 'el-slider'
          }, // 8
          {
            label: '商品间距',
            value: 8,
            sid: 'goods_weapp_s11',
            min: 0,
            max: 30,
            key: 'padding',
            type: 'style',
            tag: 'el-slider'
          }, // 9
          {
            label: '商品名称',
            value: '1',
            sid: 'goods_weapp_s4',
            showList: {
              '1': '显示',
              '2': '不显示'
            },
            key: 'goodsName',
            type: 'style',
            tag: 'radio'
          }, // 10
          {
            label: '商品描述',
            value: '2',
            sid: 'goods_weapp_s5',
            showList: {
              '1': '显示',
              '2': '不显示'
            },
            key: 'goodsInfo',
            type: 'style',
            tag: 'radio',
            isUse: false
          }, // 11
          {
            label: '商品现价',
            value: '1',
            sid: 'goods_weapp_s4',
            showList: {
              '1': '显示',
              '2': '不显示'
            },
            key: 'goodsPrice',
            type: 'style',
            tag: 'radio'
          }, // 12
          // isUse: false,
          {
            label: '商品原价',
            value: '1',
            sid: 'goods_weapp_s4',
            showList: {
              '1': '显示',
              '2': '不显示'
            },
            key: 'goodsOldPrice',
            type: 'style',
            tag: 'radio'
          }, // 13
          {
            label: '剩余库存',
            value: '2',
            sid: 'goods_weapp_s4',
            showList: {
              '1': '显示',
              '2': '不显示'
            },
            key: 'goodsSaleNum',
            type: 'style',
            tag: 'radio'
          }, // 14
          {
            label: '购买按钮',
            value: '1',
            sid: 'goods_weapp_s4',
            showList: {
              '1': '显示',
              '2': '不显示'
            },
            key: 'btnStyle',
            type: 'style',
            tag: 'select'
          }, // 15
          {
            label: '按钮样式',
            value: '1',
            sid: 'goods_weapp_s3',
            showList: {
              '1': '样式1',
              '2': '样式2',
              '3': '样式3',
              '4': '样式4',
              '5': '样式5',
              '6': '样式6',
              '7': '样式7',
              '8': '样式8'
            },
            options: {
              '1': '',
              '2': '',
              '3': '马上抢',
              '4': '购买',
              '5': '',
              '6': '',
              '7': '马上抢',
              '8': '购买'
            },
            key: 'btnText',
            type: 'style',
            tag: 'button'
          }, // 16
          {
            label: '倒计时',
            value: '1',
            sid: 'goods_weapp_s4',
            showList: {
              '1': '显示',
              '2': '不显示'
            },
            key: 'countdown',
            type: 'style',
            tag: 'radio'
          }, // 17
          {
            label: '商品销量',
            value: '2',
            sid: 'goods_weapp_s4',
            showList: {
              '1': '显示',
              '2': '不显示'
            },
            key: 'progress',
            type: 'style',
            tag: 'radio'
          }, // 18
          {
            label: '已售罄拼团商品',
            value: '2',
            sid: 'goods_weapp_s12',
            showList: {
              '1': '隐藏',
              '2': '不隐藏'
            },
            key: 'goodsTag',
            type: 'style',
            tag: 'radio',
            isUse: false
          }, // 19
          {
            label: '已团人数',
            value: '2',
            sid: 'goods_weapp_s4',
            showList: {
              '1': '显示',
              '2': '不显示'
            },
            key: 'progress',
            type: 'style',
            tag: 'radio',
            isUse: false
          }, // 20
          {
            label: '首位推荐',
            value: '2',
            sid: 'goods_weapp_s4',
            showList: {
              '1': '显示',
              '2': '不显示'
            },
            key: 'progress',
            type: 'style',
            tag: 'radio',
            isUse: false
          }// 21
        ]
      )
    }
  },
  watch: {
    // value: {
    //   handler: function(newVal){
    //     if(newVal){
    //       this.$nextTick(() => {
    //         // console.log('comp--D-ata',newVal)
    //       });

    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {

  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData () {
    },
    addClass (index) {
      this.showClassIndex = index
      this.showClassDialog = true
      console.log('??-0', index, this.showClassDialog && this.showClassIndex == index)
    },
    addSK (index) {
      console.log('??-1', index)
      this.showSKIndex = index
      this.showSKDialog = true
    },
    handleTagClose (value, i) {
      value.splice(i, 1)
    },
    addCoupon (list) {
      this.showDialog = true
    },
    addCroup (groupList) {
      groupList.push(
        {
          categoryList: []
        }
      )
      this.gprefresh = false
      this.$nextTick(() => {
        setTimeout(() => {
          this.gprefresh = true
        }, 100)
      })
    },
    // 存储秒杀商品
    // 上移
    moveUp (value, iiIndex) {
      value[iiIndex] = value.splice(iiIndex - 1, 1, value[iiIndex])[0]
    },
    // 下移
    moveDown (value, iiIndex) {
      value[iiIndex] = value.splice(iiIndex + 1, 1, value[iiIndex])[0]
    },
    // 删除
    mDelete (value, iiIndex) {
      value.splice(iiIndex, 1)
    },
    goBack (val) {
      // this.$refs.addCouponPage.dialogVisible = false
      // console.log('l;l;',val)
      this.showDialog = false
      this.showClassDialog = false
      this.showSKDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-attr_container {
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
}

.dft-header {
  margin: 5px 0;
}

.attr-item-box {
  padding: 6px 6px;

  .attr-item-typedata {
    margin-bottom: 10px;

    .attr-item-label {
      margin-bottom: 5px;
      font-size: 14px;
    }

    .attr-item-value {
      .temp-box {
        display: flex;
        flex-wrap: wrap;

        .temp-item {
          width: calc((100% - 36px)/6);
          height: 90px;
          margin: 0 3px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          .temp-item-img {
            width: 48px;
            height: 48px;
            margin-bottom: 8px;
          }

          .temp-item-name {
            font-weight: 400;
            font-size: 11px;
            line-height: 20px;
            text-align: center;
            color: #333;

            .mini_span {
              // transform: scale(.7);
            }
          }
        }

        .active_temp-item {
          .temp-item-name {
            color: #155bd4;
          }
        }
      }

      .addImgList {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        .img_info {
          color: #969799;
          font-weight: 400;
          margin-top: 8px;
          white-space: pre-wrap;
          font-size: 13px;
        }

        .imgList_box {
          // padding: 12px 0;
          width: 100%;
          box-sizing: border-box;
          // max-height: 240px;
          overflow-y: auto;

          .imgList-item {
            border: 1px solid #e0e0e0;
            margin: 12px 5px;
            padding: 4px;
            box-sizing: border-box;
            display: flex;

            .ii-img-box {
              width: 80px;
              height: 100px;
              position: relative;

              .ii-img {
                width: 100%;
                height: 100%;
              }

              .ii-img-btn {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 20px;
                background-color: rgba($color: #000000, $alpha: .5);
                text-align: center;
                font-size: 13px;
                color: #ffffff;
                cursor: pointer;
              }
            }

            .ii-link-box {
              width: calc(100% - 80px);
              box-sizing: border-box;
              height: 100px;
              padding: 0 8px;

              .ii-link-info {
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #999;
              }

              .ii-link {}
            }
          }
        }

        .upload_btn {
          background: #efefef;
          border-radius: 2px;
          padding: 6px 10px 6px 14px;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          width: -webkit-fit-content;
          width: -moz-fit-content;
          width: fit-content;
          margin: 0 auto;
          color: #333;
          cursor: pointer;
        }

        .comp-item {
          width: calc(100% - 12px);
          margin: 8px 6px;
          padding: 6px 10px 6px 14px;
          box-sizing: border-box;
          background-color: #fff;
          border-radius: 2px;
          display: flex;
          align-items: center;
          border-radius: 2px;
          background-color: #fff;
          box-shadow: 0 0 4px 0 rgba(10, 42, 97, .2);

          .goodsinfo {
            padding-left: 8px;
            font-size: 13px;
          }

          // cursor: grab;
          position: relative;
        }
        .groupitem{
          flex-direction: column;
          position: relative;
          background: #fcfcfc;
          .groupitem_line{
            width: 100%;
            margin: 6px 0;
            background: #fff;
            .ctag_item{
              margin-right: 4px;
            }
          }
          .g_l_label{
            // width: 80px;
            flex-shrink: 0;
            padding-bottom: 4px;
            color: #969799;
          }
          .ii-link-btn{
            position: absolute;
            top: 2px;
            right: 4px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-size: 18px;
            color: #969696;
            display: none;

            .icon_btn {
              font-size: 18px;
              padding: 2px;
              margin: 0 2px;
              cursor: pointer;
              &:hover{
                color: #155bd4;
              }
            }
          }
          &:hover {
            .ii-link-btn {
              display: flex;
            }
          }
        }
        .select_btn {
          width: 100%;
          margin: 8px 0 0;
          box-sizing: border-box;
          background-color: #fff;
          border: 1px solid #155bd4;
          border-radius: 2px;
          color: #155bd4;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }

  .attr-item-typestyle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    margin-bottom: 10px;

    .attr-item-label {
      // color: #969799;
      color: #333333;
      margin-right: 12px;
    }

    .attr-item-on {
      color: #333333;
      margin-right: 8px;
      font-size: 12px;
    }

    .attr-item-value {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }

}

.colorPicker {
  height: 40px;
  display: flex;
  align-items: center;
}

.custon_slider {
  width: 100%;

  /deep/.el-slider__input {
    width: 60px;
  }

  /deep/.el-slider__runway.show-input {
    margin-left: 8px;
    margin-right: 80px;
  }
}

.btn-icon {
  line-height: 20px;
  color: #f44;
}

.select-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.select-btn {
  height: 18px;
  padding: 0 8px;
}

.info-set {
  position: absolute;
  bottom: 0;
  left: 0;
  color: #969799;
  font-size: 12px;
}
</style>
